import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=61a2c65d&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=61a2c65d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2c65d",
  null
  
)

export default component.exports